// removed by extract-text-webpack-plugin
module.exports = {"Invitation":"Invitation__Invitation__2iHTu","Leader":"Invitation__Leader__3WxJv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Invitation/Invitation.css
// module id = 417
// module chunks = 0